// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../utils/colors.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/bgTry5.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Même fond et même charte que la page Login/Register, mais avec un seul panneau (le formulaire) */
.unsub-page {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  font-family: 'Montserrat', 'Segoe UI', sans-serif;
  box-sizing: border-box;
}

.unsub-card {
  width: 100%;
  max-width: 760px;
  min-height: 60vh;
  padding: 64px 72px;
  background: var(--auth-form-bg);
  border-radius: 16px;
  text-align: center;
  box-sizing: border-box;
  box-shadow:
    0 14px 28px rgba(0, 0, 0, 0.85),
    0 10px 10px rgba(0, 0, 0, 0.85);
}

.unsub-card form {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
}

.unsub-title {
  margin: 0;
  font-size: 2.1rem;
  font-weight: 700;
  color: var(--auth-title);
}

.unsub-subtitle {
  margin: 0;
  font-size: 16px;
  line-height: 1.6;
  color: var(--auth-subtitle);
}

.unsub-subtitle strong {
  color: var(--auth-title);
  word-break: break-all;
}

.unsub-field {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* ── Champs : même rendu que .form-panel input ── */
.unsub-field input,
.unsub-field textarea {
  width: 100%;
  padding: 15px 18px;
  font: inherit;
  font-size: 15px;
  background: var(--auth-input-bg);
  border: 1px solid var(--auth-input-border);
  border-radius: 8px;
  color: var(--auth-input-text);
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s;
}

.unsub-field textarea {
  resize: vertical;
  min-height: 150px;
}

.unsub-field input::placeholder,
.unsub-field textarea::placeholder {
  color: var(--auth-input-placeholder);
}

.unsub-field input:focus,
.unsub-field textarea:focus {
  border-color: var(--auth-input-border-focus);
  box-shadow: 0 0 0 2px rgba(225, 6, 19, 0.18);
}

.unsub-field .has-error {
  border-color: var(--map-danger);
}

.unsub-error {
  color: var(--map-danger);
  font-size: 12px;
  text-align: left;
  margin-top: 4px;
}

.unsub-alert {
  width: 100%;
  margin: 0;
  padding: 10px 14px;
  font-size: 13px;
  color: var(--auth-title);
  background: rgba(238, 91, 67, 0.15);
  border: 1px solid var(--map-danger);
  border-radius: 8px;
  text-align: left;
  box-sizing: border-box;
}

/* ── Bouton : même rendu que .form-panel button[type="submit"] ── */
.unsub-btn {
  display: inline-block;
  width: 70%;
  margin-top: 12px;
  padding: 16px 48px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-align: center;
  text-decoration: none;
  color: #fff;
  background: var(--map-danger-gradient);
  border: none;
  border-radius: 24px;
  cursor: pointer;
  box-sizing: border-box;
  transition: opacity 0.2s, transform 0.1s;
}

.unsub-btn:hover:not(:disabled) { opacity: 0.9; }
.unsub-btn:active:not(:disabled) { transform: scale(0.97); }

.unsub-btn:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}

.unsub-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.unsub-btn--ghost {
  background: transparent;
  border: 1px solid var(--auth-ghost-border);
  letter-spacing: 0.5px;
  padding: 12px 24px;
}

.unsub-btn--ghost:hover {
  background: var(--auth-ghost-hover-bg);
  opacity: 1;
}

.unsub-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.unsub-success__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  font-size: 1.6rem;
  color: #fff;
  background: var(--map-danger-gradient);
  border-radius: 50%;
}

/* ── Tablette ── */
@media (max-width: 900px) {
  .unsub-card {
    max-width: 640px;
    padding: 48px 40px;
  }
}

/* ── Mobile ── */
@media (max-width: 600px) {
  .unsub-page {
    padding: 0;
    align-items: stretch;
  }

  .unsub-card {
    max-width: none;
    min-height: 100vh;
    min-height: 100dvh;
    padding: 40px 20px;
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .unsub-title {
    font-size: 1.4rem;
  }

  .unsub-btn {
    width: 100%;
    padding: 13px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/templates/UnsubscribeTemplate/UnsubscribeTemplate.css"],"names":[],"mappings":"AAEA,mGAAmG;AACnG;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yDAA2D;EAC3D,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,iDAAiD;EACjD,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB;;mCAEiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,oDAAoD;AACpD;;EAEE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gCAAgC;EAChC,0CAA0C;EAC1C,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,mCAAmC;EACnC,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,oEAAoE;AACpE;EACE,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,sCAAsC;EACtC,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA,kCAAkC,YAAY,EAAE;AAChD,mCAAmC,sBAAsB,EAAE;;AAE3D;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":["@import '../../utils/colors.css';\r\n\r\n/* Même fond et même charte que la page Login/Register, mais avec un seul panneau (le formulaire) */\r\n.unsub-page {\r\n  min-height: 100vh;\r\n  min-height: 100dvh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 24px 16px;\r\n  background-image: url(\"../../../public/images/bgTry5.webp\");\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  font-family: 'Montserrat', 'Segoe UI', sans-serif;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.unsub-card {\r\n  width: 100%;\r\n  max-width: 760px;\r\n  min-height: 60vh;\r\n  padding: 64px 72px;\r\n  background: var(--auth-form-bg);\r\n  border-radius: 16px;\r\n  text-align: center;\r\n  box-sizing: border-box;\r\n  box-shadow:\r\n    0 14px 28px rgba(0, 0, 0, 0.85),\r\n    0 10px 10px rgba(0, 0, 0, 0.85);\r\n}\r\n\r\n.unsub-card form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 24px;\r\n  width: 100%;\r\n}\r\n\r\n.unsub-title {\r\n  margin: 0;\r\n  font-size: 2.1rem;\r\n  font-weight: 700;\r\n  color: var(--auth-title);\r\n}\r\n\r\n.unsub-subtitle {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  line-height: 1.6;\r\n  color: var(--auth-subtitle);\r\n}\r\n\r\n.unsub-subtitle strong {\r\n  color: var(--auth-title);\r\n  word-break: break-all;\r\n}\r\n\r\n.unsub-field {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.sr-only {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  margin: -1px;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  white-space: nowrap;\r\n  border: 0;\r\n}\r\n\r\n/* ── Champs : même rendu que .form-panel input ── */\r\n.unsub-field input,\r\n.unsub-field textarea {\r\n  width: 100%;\r\n  padding: 15px 18px;\r\n  font: inherit;\r\n  font-size: 15px;\r\n  background: var(--auth-input-bg);\r\n  border: 1px solid var(--auth-input-border);\r\n  border-radius: 8px;\r\n  color: var(--auth-input-text);\r\n  outline: none;\r\n  box-sizing: border-box;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.unsub-field textarea {\r\n  resize: vertical;\r\n  min-height: 150px;\r\n}\r\n\r\n.unsub-field input::placeholder,\r\n.unsub-field textarea::placeholder {\r\n  color: var(--auth-input-placeholder);\r\n}\r\n\r\n.unsub-field input:focus,\r\n.unsub-field textarea:focus {\r\n  border-color: var(--auth-input-border-focus);\r\n  box-shadow: 0 0 0 2px rgba(225, 6, 19, 0.18);\r\n}\r\n\r\n.unsub-field .has-error {\r\n  border-color: var(--map-danger);\r\n}\r\n\r\n.unsub-error {\r\n  color: var(--map-danger);\r\n  font-size: 12px;\r\n  text-align: left;\r\n  margin-top: 4px;\r\n}\r\n\r\n.unsub-alert {\r\n  width: 100%;\r\n  margin: 0;\r\n  padding: 10px 14px;\r\n  font-size: 13px;\r\n  color: var(--auth-title);\r\n  background: rgba(238, 91, 67, 0.15);\r\n  border: 1px solid var(--map-danger);\r\n  border-radius: 8px;\r\n  text-align: left;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* ── Bouton : même rendu que .form-panel button[type=\"submit\"] ── */\r\n.unsub-btn {\r\n  display: inline-block;\r\n  width: 70%;\r\n  margin-top: 12px;\r\n  padding: 16px 48px;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  letter-spacing: 1.4px;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  color: #fff;\r\n  background: var(--map-danger-gradient);\r\n  border: none;\r\n  border-radius: 24px;\r\n  cursor: pointer;\r\n  box-sizing: border-box;\r\n  transition: opacity 0.2s, transform 0.1s;\r\n}\r\n\r\n.unsub-btn:hover:not(:disabled) { opacity: 0.9; }\r\n.unsub-btn:active:not(:disabled) { transform: scale(0.97); }\r\n\r\n.unsub-btn:focus-visible {\r\n  outline: 2px solid #fff;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.unsub-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.unsub-btn--ghost {\r\n  background: transparent;\r\n  border: 1px solid var(--auth-ghost-border);\r\n  letter-spacing: 0.5px;\r\n  padding: 12px 24px;\r\n}\r\n\r\n.unsub-btn--ghost:hover {\r\n  background: var(--auth-ghost-hover-bg);\r\n  opacity: 1;\r\n}\r\n\r\n.unsub-success {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n\r\n.unsub-success__icon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 56px;\r\n  height: 56px;\r\n  font-size: 1.6rem;\r\n  color: #fff;\r\n  background: var(--map-danger-gradient);\r\n  border-radius: 50%;\r\n}\r\n\r\n/* ── Tablette ── */\r\n@media (max-width: 900px) {\r\n  .unsub-card {\r\n    max-width: 640px;\r\n    padding: 48px 40px;\r\n  }\r\n}\r\n\r\n/* ── Mobile ── */\r\n@media (max-width: 600px) {\r\n  .unsub-page {\r\n    padding: 0;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .unsub-card {\r\n    max-width: none;\r\n    min-height: 100vh;\r\n    min-height: 100dvh;\r\n    padding: 40px 20px;\r\n    border-radius: 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n  }\r\n\r\n  .unsub-title {\r\n    font-size: 1.4rem;\r\n  }\r\n\r\n  .unsub-btn {\r\n    width: 100%;\r\n    padding: 13px 20px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
